export default __webpack_public_path__ + "static/media/IMG_2091.6bc11d56.JPG";